import { render, staticRenderFns } from "./ContrastSpecialty.vue?vue&type=template&id=56c5ad9a&scoped=true"
import script from "./ContrastSpecialty.vue?vue&type=script&lang=js"
export * from "./ContrastSpecialty.vue?vue&type=script&lang=js"
import style0 from "./ContrastSpecialty.vue?vue&type=style&index=0&id=56c5ad9a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c5ad9a",
  null
  
)

export default component.exports